module.exports = __webpack_public_path__ + "media/images/ceremony/top/reason1-b28372d29bca39c650f11a348f9434d7.jpg";